import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { AccountPlan } from '../../../accounting/model/account-plan';
import { AccountPlanService } from '../../../accounting/service/data/account-plan.service';
import { FormComponentBase } from '../../../core/component/forms/form-component.base';
import { DataService } from '../../../core/service/base/data.service';
import { CommandDispatcher } from '../../../core/service/command/command-dispatcher.service';
import { DeleteFormCommandHandler } from '../../../core/service/command/delete-form-command-handler.service';
import { FormCommandHandlerResolver } from '../../../core/service/command/form-command-handler-resolver.service';
import { FormControlExFactory } from '../../../core/service/factory/form-control-ex-factory.service';
import { MessageService } from '../../../core/service/message.service';
import { NavigationService } from '../../../core/service/navigation.service';
import { ActivatedRoute } from '@angular/router';
import { standardCommand } from '../../../core/model/command';
import { PriceListService } from '../../service/pricelist.service';
import { PriceList } from '../../model/pricelist';
import { SelectionItem } from '../../../core/component/select/select.component';
import { PriceListItem } from '../../model/priceListItem';
import { CurrencySymbol, Money } from '../../../core/model/money';
import { LocalDate } from '../../../core/model/local-date';
import { MeterMediaTypeSelection } from '../../model/const/enums';
import { CompanyService } from '../../../rent/service/data/company.service';
import { finalize, switchMap } from 'rxjs/operators';
import { ImdImportService } from '../../service/imd-import.service';
import { ImdImport } from '../../model/ImdImport';
import { FileService, IFileValidator } from '../../../core/service/file.service';
import { HttpClient } from '@angular/common/http';

class FileValidator extends FileService {
  constructor(httpClient: HttpClient) {
    super(httpClient);
  }

  validateDocument(document: File): string {
    return ['txt', 'csv', 'kim'].includes(this.getExtension(document.name).toLowerCase())
      ? null
      : 'CONSUMPTION.IMPORT.FILE_TYPE_VALIDATION_ERROR';
  }
}

@Component({
    selector: 'app-imd-import-add-form',
    templateUrl: './import-add-form.component.html',
    providers: [DeleteFormCommandHandler, FormCommandHandlerResolver, { provide: DataService, useExisting: ImdImportService }],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ImdImportAddFormComponent extends FormComponentBase<ImdImport> {
  constructor(
    private _fb: FormBuilder,
    private _fc: FormControlExFactory,
    companyService: CompanyService,
    activatedRoute: ActivatedRoute,
    commandDispatcher: CommandDispatcher,
    handlerResolver: FormCommandHandlerResolver,
    private _service: ImdImportService,
    messageService: MessageService,
    navigation: NavigationService,
    httpClient: HttpClient
  ) {
    super(activatedRoute, _service, messageService, navigation, commandDispatcher, handlerResolver);
    this.companyService = companyService;
    this.fileValidator = new FileValidator(httpClient);
  }

  protected createModel(): ImdImport {
    return new ImdImport();
  }

  fileValidator: IFileValidator;
  companyService: CompanyService;

  selectedFile: File;
  filesSelected(selection: FileList) {
    if (!selection || selection.length == 0) {
      this.selectedFile = null;
      this.form.controls['fileName'].setValue(null);
      this.form.controls['fileName'].markAllAsTouched();
      return;
    }
    this.selectedFile = selection.item(0);
    this.form.controls['fileName'].setValue(this.selectedFile.name);
    this.form.controls['fileName'].markAllAsTouched();
  }

  working: boolean = false;
  onSubmit() {
    this.form.markAllAsTouched();
    if (this.selectedFile == null || this.working || this.form.invalid) return;
    this.working = true;
    this.AddSubscription(
      this._service
        .upload(this.selectedFile, this.form.controls['companyId'].value)
        .pipe(
          finalize(() => {
            this.working = false;
          })
        )
        .subscribe(id => {
          if (id) {
            this.form.markAsPristine();
            this.navigation.navigateToForm(id);
          }
        })
    );
  }

  protected getFormGroup(): FormGroup {
    return this._fb.group({
      companyId: this._fc.createMandatory('COMMON.COMPANY', null),
      fileName: this._fc.createWithOptions('CONSUMPTION.IMPORT.IMPORT_IDENTIFIER', null, { isReadonly: true, required: true }),
    });
  }
}
